import { DurationType } from './interfaces/DurationType';

export const timeConfig: Record<DurationType, string> = {
  [DurationType.Hour]: '50 минут',
  [DurationType.HourAndHalf]: '80 минут',
};
